/* eslint-disable object-shorthand */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-else-return */
/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/require-default-props */
import React, { forwardRef, HTMLAttributes, SetStateAction, useEffect, useState } from 'react';
import { BorderColor, Close, CloseOutlined, Edit, Info, LabelRounded, Tune } from '@material-ui/icons';
import { Bar, Doughnut, Line, Pie, PolarArea } from 'react-chartjs-2';
import { v4 as uuidv4 } from 'uuid';
import { Chart as ChartJS, RadialLinearScale, ArcElement, Tooltip as ChartTooltip, Legend } from 'chart.js';
import { Tooltip } from '@material-ui/core';
import hash from "object-hash";
import darkStyles from './LiveDark.module.css';
import lightStyles from './LiveLight.module.css';
import {
  barChartOptions,
  formatSecondsToDuration,
  donutChartOptions,
   getMetricLabel,
  Widget,
  populatePieRelativeData,
  PieChartOptions,
  barChartTimeTicks,
  deleteGridItem,
  chartBgs,
  QuickWidget
} from './Utilities';
import RenderQuickWidget from './QuickWidgets';
import { QueueCallState } from '../QueueLeaderboard';


ChartJS.register(RadialLinearScale, ArcElement, ChartTooltip, Legend);

export interface ILayoutValues {
  // id value
  i: string | number;
  x: number;
  y: number;
  w: number;
  h: number;
}
interface CustomGridItemProps extends HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  accessToken: string;
  lightMode?: boolean;
  quickEditMode: boolean;
  onDragStart?: () => void;
  layout: ILayoutValues;
  widgetContent: Widget | undefined;
  deltas: any;
  historicalUsers: any;
  historicalQueues: any;
  editWidget: (widgetId: string) => void;
  queueCallStates: QueueCallState[] | undefined;
  setWidgets: React.Dispatch<SetStateAction<Map<string, Widget>>>;
  widgets: Map<string, Widget>;
  setLiveDashboardErrorMsg: React.Dispatch<SetStateAction<string | undefined>>;
}

interface IGridItemHeader {
  quickEditMode: boolean;
  styles: any;
  accessToken: string;
  layout: CustomGridItemProps['layout'];
  widgetContent: Widget | undefined;
  editWidget: (widgetId: string) => void;
  widgets: Map<string, Widget>;
  setWidgets: React.Dispatch<SetStateAction<Map<string, Widget>>>;
  setLiveDashboardErrorMsg: React.Dispatch<SetStateAction<string | undefined>>;
}

const CustomWidgetBodyRenderer = ({
  deltas,
  widgetContent,
  historicalUsers,
  historicalQueues,
  accessToken,
}: {
  deltas: Map<string, any>;
  widgetContent: Widget | undefined;
  historicalUsers: any[];
  historicalQueues: any;
  accessToken: string;
}) => {
  const { visualType, metricValues, metrics, key, quickWidgetType } = widgetContent || {};
  const [customChartData, setCustomChartData] = useState<any>();
  const [kpiData, setKpiData] = useState<any>();
  const id = uuidv4();
  
  useEffect(() => {
    const labels: string[] = [];
    const datasets: any[] = [];
    const backgrounds: any[] = [];
    let list: any = [];
    if (widgetContent?.dimensionType === 'users') list = historicalUsers;
    if (widgetContent?.dimensionType === 'queues') list = historicalQueues;

    if (!deltas.size) {
      console.log('NO DELTAS: ', deltas);
      return;
    }
      
      if (visualType === 'bar') {
        labels.push(
          ...(metricValues || []).map((_id) => {
            return list?.find((entity: any) => entity.id === _id)?.name ?? _id;
          }),
        );

        metrics?.forEach((_metric, metricIndex) => {
          const data = (metricValues || []).map((_id) => {
            return deltas.get(_id)?.[_metric] ?? 0;
          });

          datasets.push({ 
            label: getMetricLabel(_metric),
            data,
            backgroundColor: chartBgs[metricIndex % chartBgs.length],
            metricKey: _metric,
            metricValueNames: (metricValues || []).map((_id) => {
              return list?.find((entity: any) => entity.id === _id)?.name ?? _id;
            }),
          });
        });
      }
      if (visualType === 'pie' || visualType === 'donut') {
        if (key === 'example') {
          datasets.push({
            data: [1, 2,6],
             backgroundColor: ["red"],
              borderColor: ['#00000000'],
              spacing: 2,
              offset: 10,
              weight: 1,
              borderRadius: 6,
          })
        }
          metrics?.forEach((_metric, metricIndex) => {
            const entries = (metricValues || []).map((_id, index) => {
              const value = deltas.get(_id)?.[_metric] ?? 0;

              return {
                id: _id,
                name: list?.find((user: any) => user.id === _id)?.name ?? _id,
                value,
                color: chartBgs[index % chartBgs.length],
              };
            });

            const sortedEntries = [...entries].sort((a, b) => b.value - a.value);

            const topEntries = sortedEntries.slice(0, 12);
            const otherEntries = sortedEntries.slice(12);

            if (otherEntries.length > 0) {
              const otherTotal = otherEntries.reduce((sum, entry) => sum + entry.value, 0);
              topEntries.push({
                id: 'other',
                name: 'Other',
                value: otherTotal,
                color: '#999999',
              });
            }
            const data = topEntries.map((entry) => entry.value);
            const labelSlice = topEntries.map((entry) => entry.name);
            const colors = topEntries.map((entry) => entry.color);

            datasets.push({
              id: metricIndex,
              data,
              backgroundColor: colors,
              borderColor: ['#00000000'],
              spacing: 2,
              offset: 10,
              weight: 1,
              borderRadius: 6,
              metricKey: _metric,
              metricValueNames: labelSlice,
            });

            labels.push(...labelSlice);
          });
        
 
    }
    setCustomChartData({
      labels,
      datasets,
    });
  }, [deltas, metricValues, metrics, visualType]);

  const isTimeBased = metrics?.some(
    (metric: any) => metric?.toLowerCase()?.includes('duration') || metric?.toLowerCase()?.includes('time'),
  );
  if (key === 'kpi') {
    return <h1>{JSON.stringify(customChartData)}</h1>;
  }
  if (key === 'customized') {
    if (!customChartData)
      return (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#55555588',
          }}
        >
          no data to display.
        </div>
      );

      if (visualType === 'bar') return <Bar data={customChartData} options={{ ...barChartOptions as any, ...(isTimeBased ? barChartTimeTicks : {}),}}/>
      if (visualType === 'donut') return <Doughnut data={customChartData} options={donutChartOptions as any} />;
      if (visualType === 'pie') return <Pie data={customChartData} options={PieChartOptions as any} />;
    
  }
  return <></>;
};

export const GridItemHeader = ({
  quickEditMode,
  styles,
  layout,
  widgetContent,
  editWidget,
  setWidgets,
  widgets,
  setLiveDashboardErrorMsg,
}: IGridItemHeader) => {
  const id = layout.i;
  return (
    <div className={styles.gridItemHeader}>
      {quickEditMode && (
        <>
          <span className={styles.gridItemHandleEdit} id="grid-item-handle">
            {widgetContent?.title || widgetContent?.label}
          </span>
          <span style={{display: 'flex'}}>
             <button
              className={styles.editButton}
              type="button"
              onClick={() => editWidget(widgetContent?.widgetId as string)}
            >
              <Tune fontSize="small" style={{ width: 15, height: 15 }} />
            </button>
            <button
              className={styles.deleteButton}
              type="button"
              onClick={() => deleteGridItem(id, setWidgets, widgets, setLiveDashboardErrorMsg)}
            >
              <CloseOutlined fontSize="small" style={{ width: 13, height: 13 }} />
            </button>
          </span>
        </>
      )}
      {!quickEditMode && (
        <span className={styles.gridItemHandle} id="grid-item-handle">
            {widgetContent?.title || widgetContent?.label}
          </span>
      )}
    </div>
  );
};

const KPIWidgetBodyRenderer = ({
  widgetContent,
  styles,
  layout,
  deltas,
}: {
  widgetContent: Widget | undefined;
  styles: any;
  layout: ILayoutValues;
  deltas: Map<string, any>;
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', justifyContent: 'center' }}>
      {widgetContent?.metrics?.[0]?.toLowerCase()?.includes('count') && (
        <>
          <h1 className={styles?.kpiBigText} style={{ fontSize: `${layout?.h * 1.5}em`, margin: 0, color: widgetContent?.cosmetics?.color || "" }}>
            {JSON.stringify(
              Array.from(deltas?.values()).reduce((acc, item: any) => {
                return acc + (item[widgetContent?.metrics as any] ?? 0);
              }, 0),
            )}
          </h1>
        </>
      )}
      {/* time */}
      {(widgetContent?.metrics?.[0]?.toLowerCase()?.includes('time') ||
        widgetContent?.metrics?.[0]?.toLowerCase()?.includes('duration')) && (
        <>
          <h1 style={{ fontSize: `${layout.h * 1.5}em`, margin: 0, textAlign: 'center', color: widgetContent?.cosmetics?.color || "" }} className={styles.kpiBigText}>
            {formatSecondsToDuration(
              Math.floor(
                Array.from(deltas?.values())?.reduce((acc: number, item: any) => {
                  if (Array.isArray(widgetContent.metrics)) {
                    return (
                      acc +
                      widgetContent?.metrics?.reduce((sum, key) => {
                        const value = item?.[key];
                        return sum + (typeof value === 'number' ? value : 0);
                      }, 0)
                    );
                  } else {
                    const value = item?.[widgetContent?.metrics as any];
                    return acc + (typeof value === 'number' ? value : 0);
                  }
                }, 0) / 1000,
              ),
            )}
          </h1>
          {/* <h1 style={{fontSize: `${(layout.h / 2.8)}em`, margin: 0,  textAlign: 'center'}}>{getMetricLabel(widgetContent?.metrics?.[0])}</h1> */}
        </>
      )}
    </div>
  );
};
export const WidgetContainerBar = ({value, styles}: {styles: any; value: {data:  number[]; labels: string[]}}) => {

if (!value) return <div />
 return (
  <div className={styles.gridItemContainerInner}>        
      <div className={styles.gridItemBody}>
        <Bar 
        options={{...barChartOptions, plugins: {legend: {display: false}}}}
          data={{
            labels: value?.labels ?? [""],
            datasets: [{
              data: value?.data ?? [0, 0],
              borderWidth: 1,
              backgroundColor: chartBgs
            }]}}
          />
      </div>
    </div>
  )}

export const WidgetContainer = ({
layout,
styles,
cosmetics,
accessToken,
mode,
value,
subHeading,
threshold
}:{
layout: ILayoutValues;
styles: any;
cosmetics: QuickWidget['cosmetics'];
accessToken?: string;
mode?: string;

value?: string | number | null | undefined;
subHeading?: string | number | undefined;
threshold?: string | number | undefined;
}) => {

  const fontSize = `${layout.h}rem`;
  const subHeadingFontSize = `${layout.h / 5}rem`
  const color = cosmetics?.color ?? mode === 'light' ? "black" : "white";

  const mainValue = value ?? "0" // the large text.
  const subHeadingValue = subHeading ?? "subheading void" // text underneath main value
  const thresholdValue = threshold ?? 10;  // little pill text on the bottom
  return (
    <div className={styles.widgetContainer}>
      <div className={styles.widgetContent}>
        <div className={styles.widgetContentHeader} style={{fontSize: fontSize, }}>
        {mainValue}
        </div>
        <div className={styles.widgetContentSubheader} style={{fontSize: subHeadingFontSize}} >
          {subHeadingValue}
        </div>

      </div>
      {!threshold && <div className={styles.widgetSubheading} />}
      {
      threshold && (
      <div className={styles.widgetSubheading}>
        <div className={styles.widgetSubheadingContent}>
          Threshold: {thresholdValue}
        </div>
      </div>
    )
  }

    </div>
  )
}

export const CustomizedWidgetGridItem = ({
      historicalUsers,
      historicalQueues,
      accessToken,
      deltas,
      lightMode,
      widgetContent,
    }: CustomGridItemProps) => {
    const styles = lightMode ? lightStyles : darkStyles;
    return (
      <div  className={styles.gridItemContainerInner}>
        <div className={styles.gridItemBody} style={{height: '100%'}} >        
          <CustomWidgetBodyRenderer
            accessToken={accessToken}
            widgetContent={widgetContent}
            deltas={deltas}
            historicalUsers={historicalUsers}
            historicalQueues={historicalQueues}
          />
        </div>
      </div>
    );
  }

export const KPIWidgetGridItem = ({
      deltas,
      widgetContent,
      layout,
      lightMode,
    } : CustomGridItemProps
  ) => {
    const styles = lightMode ? lightStyles : darkStyles;
    return (
      <div className={styles.gridItemContainerInner}>
        <div className={styles.gridItemBody}>
          <KPIWidgetBodyRenderer styles={styles} layout={layout} deltas={deltas} widgetContent={widgetContent} />
        </div>
      </div>
    );
  }
